import React, { useState, useEffect } from 'react';
import { settingsApi } from '../api/client';
import { useFlash, F } from '../components/UI';

export default function Settings() {
  const { show, Flash } = useFlash();
  const [upiId,   setUpiId]   = useState('');
  const [upiName, setUpiName] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving,  setSaving]  = useState(false);

  useEffect(() => {
    settingsApi.get().then(({ data }) => {
      setUpiId(data.upi_id || '');
      setUpiName(data.upi_name || '');
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const saveUpi = async () => {
    setSaving(true);
    try {
      await settingsApi.update({ upi_id: upiId.trim(), upi_name: upiName.trim() });
      show('UPI settings saved!');
    } catch {
      show('Failed to save settings.', 'error');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      <Flash/>
      <div className="card" style={{ marginBottom: 16 }}>
        <div className="card-hd">
          <div className="card-title">Company Information</div>
        </div>
        <div className="card-body">
          <div className="fg-2">
            <F label="Company Name"><input defaultValue="Sakthi Solar Solutions"/></F>
            <F label="Phone"><input defaultValue="9446191276, 9846065984, 0479 2305650, 2309650"/></F>
            <F label="Address" full><input defaultValue="East Nada, Sree Mahadevar Temple, Kandiyoor, Mavelikara, Pin-690103"/></F>
            <F label="Email"><input defaultValue="info@sakthiinverters.com"/></F>
            <F label="Website"><input defaultValue="www.sakthiinverters.com"/></F>
            <F label="Customer ID Prefix"><input readOnly defaultValue="SSS" style={{background:'var(--surface)',color:'var(--text2)',cursor:'not-allowed'}}/></F>
          </div>
          <div style={{marginTop:20}}>
            <button className="btn btn-primary" onClick={()=>show('Settings saved!')}>Save Changes</button>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-hd">
          <div className="card-title">UPI Payment Settings</div>
          <div style={{ fontSize: 12, color: 'var(--text2)', marginTop: 2 }}>
            Used to generate payment QR codes for field staff
          </div>
        </div>
        <div className="card-body">
          {loading ? (
            <div style={{ color: 'var(--text3)', fontSize: 13 }}>Loading…</div>
          ) : (
            <>
              <div className="fg-2" style={{ marginBottom: 16 }}>
                <F label="UPI ID" full>
                  <input
                    value={upiId}
                    onChange={e => setUpiId(e.target.value)}
                    placeholder="e.g. sakthisolar@okaxis"
                  />
                </F>
                <F label="UPI Display Name" full>
                  <input
                    value={upiName}
                    onChange={e => setUpiName(e.target.value)}
                    placeholder="e.g. Sakthi Solar Solutions"
                  />
                </F>
              </div>
              <button className="btn btn-primary" onClick={saveUpi} disabled={saving}>
                {saving ? 'Saving…' : 'Save UPI Settings'}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
